import { memo } from 'react';

import { MediaPath } from '../config/Constants';
import i18n from '../config/i18n';

const RingSpinner = `${MediaPath}ring-loader-70px-2x.gif`;

function LoadingSpinner({ message: messageProp = i18n.t('common.labels.loading'), noMessage = false, className = '' }) {
    let message = messageProp;
    let classforMessage = '';

    if (noMessage) {
        classforMessage = 'tw:sr-only';
        message = '';
    }

    return (
        <div className={className}>
            <img
              src={RingSpinner}
              height="35"
              width="35"
              alt=""
            />
            &nbsp;
            <span className={classforMessage}>{message}</span>
        </div>
    );
}

export default memo(LoadingSpinner);
